// eslint-disable-next-line
export default{
    // Overridable so the two instances can run side by side locally: ./dev.sh is
    // Firefleet on 5050, ./swarm-dev.sh is SwarmSystems on 5051 against its own
    // database. Unset in production, where the Vercel proxy keeps cookies
    // same-origin and must not be bypassed.
    API_ENDPOINT: process.env.REACT_APP_API_ENDPOINT
        || (process.env.NODE_ENV === 'production'
            ? '/api'                        // Production: Vercel proxy (same-origin cookies)
            : 'http://localhost:5050/api'), // Local dev: direct to backend
    // Studio "producer" planning app — origins for the share UI and the
    // public share JSON API. Overridable via env so staging can repoint.
    SITE_MAP_SHARE_HOST: process.env.REACT_APP_SITE_MAP_SHARE_HOST || 'producer.fireflystudio.app',
    SITE_MAP_API_BASE:   process.env.REACT_APP_SITE_MAP_API_BASE   || 'https://api.fireflystudio.app/producer',
}